/*
 * Pandectes cookie-consent helper
 * Checks _pandectes_gdpr cookie directly as per snippets/pandectes-rules.liquid.
 * Exposes window.themeConsent
 *
 * Cookie is base64-encoded JSON whose `preferences` field is a bitmask of
 * BLOCKED categories: 1 = functionality, 2 = performance, 4 = targeting
 * (default 7 = all blocked until the shopper chooses). A category is granted
 * when its bit is clear, e.g. functionality granted when (preferences & 1) === 0.
 *
 * Loaded early (global-head-includes) to be available to e.g. recently-viewed.js, bis-drawer.js
 */
(function () {
  if (window.themeConsent) return;

  var CATEGORY = { FUNCTIONALITY: 1, PERFORMANCE: 2, TARGETING: 4 };

  function read() {
    var parts = ('; ' + document.cookie).split('; _pandectes_gdpr=');
    if (parts.length < 2) return null;
    try {
      return JSON.parse(atob(parts.pop().split(';').shift()));
    } catch (e) {
      return null;
    }
  }

  // Conservative default: missing/undecided consent counts as NOT granted.
  function granted(category) {
    var consent = read();
    return !!consent && consent.preferences != null && (consent.preferences & category) === 0;
  }

  window.themeConsent = {
    CATEGORY: CATEGORY,
    read: read,
    granted: granted,
    functionalityGranted: function () {
      return granted(CATEGORY.FUNCTIONALITY);
    },
    performanceGranted: function () {
      return granted(CATEGORY.PERFORMANCE);
    },
    targetingGranted: function () {
      return granted(CATEGORY.TARGETING);
    },
  };
})();
